import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { PromotionType } from '../../redux/slices/cartSlice';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import DiscountIcon from '@mui/icons-material/Discount';

export default function NPlusOneFreeDialog({ promotionType, open, onConfirm }) {
  const { t } = useTranslation();

  const contentText = useMemo(() => {
    if (promotionType === PromotionType.ONE_PLUS_ONE) {
      return (
        <>
          {t('For this event the campaign is active')}
          <span style={{ fontWeight: 'bold' }}>{t(' 1+1 FREE!')}</span>
          <br />
          {t('Add\n          2 tickets to the cart and pay only for 1!')}
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>{t('Important:')}</span>
          {t('The offer is valid for tickets in the same\n          price category!')}
        </>
      );
    } else if (promotionType === PromotionType.THREE_PLUS_ONE) {
      return (
        <>
          {t('For this event the campaign is active')}
          <span style={{ fontWeight: 'bold' }}>{t('3+1 GRATUIT!')}</span>
          {t('Add 4 tickets to the cart and pay only for 3!')}
          <br />
          <br />
          <span style={{ fontWeight: 'bold' }}>{t('Important:')}</span>
          {t('The offer is valid for tickets in the same\n          price category!')}
        </>
      );
    }
    return '';
  }, [promotionType, t]);

  if (!promotionType || promotionType === PromotionType.NONE) return;

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <DiscountIcon sx={{ marginRight: 1 }} />
          {t('Promoție!')}
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>{contentText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} variant="contained">
          {t('Got it')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
